<template>
    <div class="">
        <form method="POST" :action="targetUrl">
            <input type="hidden" name="_token" :value="csrf" />
            <input type="hidden" name="_return_redirect" value="false" />
            <input type="hidden" name="fahrenheit_toggle" v-model="temp">
            <input type="hidden" name="notifications_toggle" v-model="doNotifications">
            <install-wizard-card>
                <template #top-header>
                    Site Configuration
                </template>
                <template #top-content>
                    Choose a couple of common settings to get us moving along!
                </template>

                <template #body-summary>

                </template>

                <template #body-action>
                    <div class="px-4 sm:px-12">
                        <div class="pt-2">
                            <div class="">
                                <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                                    <label for="site_name"
                                           class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
                                        What do you want your site to be called?
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2 w-full">
                                        <floating-input     id="site_name"
                                                            v-model:value="siteName"
                                                            label="Site Name"
                                        ></floating-input>
<!--                                        <div class="max-w-xs rounded-md shadow-sm">-->
<!--                                            <input type="text"-->
<!--                                                    id="site_name"-->
<!--                                                    name="site_name"-->
<!--                                                    :value="siteName"-->
<!--                                                    class="block w-full sm:text-sm sm:leading-5"/>-->
<!--                                        </div>-->
                                    </div>
                                </div>

                                <div class="mt-6 sm:mt-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-center sm:border-t sm:border-gray-200 sm:pt-5">
                                    <label class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
                                        Sonicu defaults to Celsius for fridge/freezer monitoring. Would you like to use Fahrenheit instead?
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                      <span class="relative z-0 inline-flex shadow-sm rounded-md">
                                        <button
                                            type="button"
                                            @click="temp = false"
                                            :class="!temp ? 'bg-blue-200' : 'bg-white'"
                                            class="relative inline-flex items-center px-4 py-2 rounded-l-md border border-gray-300 text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:ring-blue-200 active:bg-gray-100 active:text-gray-700">
                                          Celsius
                                        </button>
                                        <button
                                            type="button"
                                            @click="temp = true"
                                            :class="temp ? 'bg-blue-200' : 'bg-white'"
                                            class="-ml-px relative inline-flex items-center px-4 py-2 rounded-r-md border border-gray-300 text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:ring-blue-200 active:bg-gray-100 active:text-gray-700">
                                          Fahrenheit
                                        </button>
                                      </span>
                                    </div>
                                </div>
                                <div class="mt-6 sm:mt-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                                    <label for="timezone" class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
                                        What is your site's timezone?
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                      <select2
                                          :close-on-select="true"
                                          :options="timezones"
                                          v-model:value="timezoneSelected"
                                          value="timezoneSelected"
                                          id="timezone"
                                          name="timezone"
                                        >
                                      </select2>
                                    </div>
                                </div>
                                <div class="mt-6 sm:mt-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-center sm:border-t sm:border-gray-200 sm:pt-5">
                                    <label class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
                                        Should non-administrative users be able to set their own notification methods upon first login or will
                                        admins configure that?
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                      <span class="relative z-0 inline-flex shadow-sm rounded-md">
                                        <button
                                            type="button"
                                            @click="doNotifications = false"
                                            :class="!doNotifications ? 'bg-blue-200' : 'bg-white'"
                                            class="relative inline-flex items-center px-4 py-2 rounded-l-md border border-gray-300 text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:ring-blue-200 active:bg-gray-100 active:text-gray-700">
                                          Admins Only
                                        </button>
                                        <button
                                            type="button"
                                            @click="doNotifications = true"
                                            :class="doNotifications ? 'bg-blue-200' : 'bg-white'"
                                            class="-ml-px relative inline-flex items-center px-4 py-2 rounded-r-md border border-gray-300 text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:ring-blue-200 active:bg-gray-100 active:text-gray-700">
                                          Users Set Notifications First Login
                                        </button>
                                      </span>
                                    </div>
                                </div>
                                <div class="mt-6 sm:mt-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-center sm:border-t sm:border-gray-200 sm:pt-5">
                                    <div>
                                        <label      v-if="snapEnabled"
                                                    class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
                                            Great! Sonicu will take care of your calibrations & send you new
                                            probes automatically.
                                        </label>
                                        <label     v-else
                                                   class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
                                            You're not set up for SNAP, contact Sales or your CSM if you want Sonicu to send you
                                            new NIST Certified probes automatically.
                                        </label>
                                    </div>

                                    <div>
                                        <span   v-if="snapEnabled"
                                                class="p-1 px-2 bg-green-100 border border-green-300 rounded-md">
                                            SNAP Purchased
                                        </span>
                                        <span   v-else
                                                class="p-1 px-2 bg-yellow-100 border border-yellow-300 rounded-md">
                                            SNAP Not Purchased
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>

                <template #bottom-header>
                    Done with these settings?
                </template>
                <template #bottom-content>
                    Save and move on to the next step; you can always come back later if you'd like!
                </template>
                <!--            <template #bottom-button-text></template>-->
                <template #bottom-button>
                    <a class="plain-link">
                        <button type="submit"
                                class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:ring-blue-200 focus:border-blue-700 active:bg-blue-700">
                            <slot name="bottom-button-text">Save Settings!</slot>
                        </button>
                    </a>
                </template>
            </install-wizard-card>
        </form>
    </div>
</template>

<script>
    import InstallWizardCard from "./InstallWizardCard";
    import Toggle from "@/components/elements/toggle";
    import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
    import Select2 from "@/components/elements/select2";
    import FloatingInput from "@/components/elements/FloatingInput.vue";

    export default {
        name: "InstallWizardSiteConfig",
        mixins: [SonicuCoreMixin],
        components: {FloatingInput, Toggle, InstallWizardCard, Select2},
        props: {
            route: String,
            temperature: String,
            siteName: String,
            timezone: String,
            snapPurchased: Boolean,
            setNotification: Boolean,
            timezones: Object,
        },
        data() {
            return {
                temp: false,
                doNotifications: this.setNotification,
                timezoneSelected: this.timezone,
            }
        },
        mounted() {
            this.temp = this.temperatureDefault
        },
        methods: {
        },
        computed: {
            targetUrl(){
                return this.company.buildCompanyRoute('wizard/'+this.route);
            },
            temperatureDefault(){
                return this.temperature != 'C';
            },
            snapEnabled() {
                return this.snapPurchased
            },
        }
    }
</script>

<style scoped>

</style>
